var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "27px",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB-ADMIN-(Web)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Parties-prenantes---Clients",
    transform: "translate(-939.000000, -1394.000000)",
    fill: "#E6433C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(898.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.227,1395.25 L70.723,1418.62 C70.847,1418.84 70.912,1419.08 70.912,1419.33 C70.912,1419.58 70.847,1419.83 70.723,1420.04 C70.598,1420.26 70.42,1420.44 70.204,1420.56 C69.989,1420.68 69.745,1420.75 69.496,1420.75 L42.505,1420.75 C42.257,1420.75 42.013,1420.68 41.797,1420.56 C41.582,1420.44 41.403,1420.26 41.279,1420.04 C41.154,1419.83 41.089,1419.58 41.089,1419.33 C41.089,1419.08 41.154,1418.84 41.279,1418.62 L54.774,1395.25 C54.898,1395.03 55.077,1394.86 55.292,1394.73 C55.508,1394.61 55.752,1394.54 56.001,1394.54 C56.249,1394.54 56.494,1394.61 56.709,1394.73 C56.924,1394.86 57.103,1395.03 57.227,1395.25 Z M44.959,1417.92 L67.042,1417.92 L56.001,1398.79 L44.959,1417.92 Z M54.584,1413.67 L57.417,1413.67 L57.417,1416.5 L54.584,1416.5 L54.584,1413.67 Z M54.584,1403.75 L57.417,1403.75 L57.417,1410.83 L54.584,1410.83 L54.584,1403.75 Z",
    id: "alert"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.da8ef8aea52b595dbc180b24845bd16a.svg";
export { ForwardRef as ReactComponent };